<span
  *ngIf="!isLoading"
  #iconContainer
  [ngStyle]="{
    height: height + 'px',
    width: width + 'px',
    padding: padding + 'px',
    background: backgroundColor,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    borderRadius: backgroundColor !== 'transparent' ? '50%' : '0',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: strokeColor || color || 'currentColor',
  }"
  (click)="handleClick($event)"
></span>

<div
  *ngIf="isLoading"
  class="loading-spinner"
  [ngStyle]="{
    height: height + 'px',
    width: width + 'px',
    borderColor: iconLoaderColor + ' transparent transparent transparent',
  }"
></div>
